import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const AspectRatioIcon = memo(() => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M14.65 16.35h3.7v-3.7h-.7v3h-3v.7Zm-9-5h.7v-3h3v-.7h-3.7v3.7ZM3.3 18.7V5.3h17.4v13.4H3.3ZM4 18h16V6H4v12Z"
      />
    </svg>
  </IconWrapper>
));
